/** Enum for element visibility states. */
export enum VisibilityState {
  Hidden = 'hidden',
  Visible = 'visible'
}
